import React from 'react'
import { Button } from '../ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import { Badge } from '../ui/badge'
import { Progress } from '../ui/progress'
import { Plus } from 'lucide-react'
import { TOOLBOX_ITEMS, getStatusIcon, ToolboxItem } from './brandDashboardData'

interface ToolboxGridProps {
  onItemClick: (item: ToolboxItem) => void
}

export function ToolboxGrid({ onItemClick }: ToolboxGridProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">Brand Design Toolbox</h2>
          <p className="text-slate-600">Complete these tools to build your comprehensive brand identity</p>
        </div>
        <Button 
          size="sm" 
          className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Custom Tool
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TOOLBOX_ITEMS.map((item) => (
          <Card 
            key={item.id}
            className="cursor-pointer hover:shadow-lg transition-shadow border-0 shadow-sm"
            onClick={() => onItemClick(item)}
          >
            <CardHeader className="pb-3">
              <div className="flex items-start justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex items-center justify-center">
                    {item.icon}
                  </div>
                  <div className="flex-1">
                    <CardTitle className="text-base">{item.title}</CardTitle>
                    <div className="flex items-center space-x-2 mt-1">
                      <Badge variant="outline" className="text-xs">
                        {item.category}
                      </Badge>
                      <span className="text-xs text-slate-500">{item.estimatedTime}</span>
                    </div>
                  </div>
                </div>
                {getStatusIcon(item.status)}
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-slate-600 mb-3">{item.description}</p>
              <div className="space-y-2">
                <div className="flex items-center justify-between text-xs">
                  <span>Progress</span>
                  <span>{item.progress}%</span>
                </div>
                <Progress value={item.progress} className="h-1" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}